import type { FC } from "react";

import { CardTypesSearchForm } from "src/app/features/CardType/components/forms/CardTypesSearchForm";
import { CardTypesTable } from "src/app/features/CardType/components/tables/CardTypesTable";
import type { CardTypeList } from "src/app/features/CardType/types/CardTypeList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const CardTypesPage: FC<NoneOwnProps> = () => {
    const table = <CardTypesTable />;
    const searchForm = <CardTypesSearchForm />;
    const hasAccess = canAccess(ResourceName.CARD_TYPES, "canRead");

    return (
        <PageLayout name="cardTypes_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.cardTypes" />
                    <ResourceManager<CardTypeList>
                        useDataGroup
                        dataMapperKey="cardTypesTableData"
                        resource={ResourceName.CARD_TYPES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
